/**
 * Number-bordered stat tile used in the Post-Completion summary header
 * + dashboards. Reused via the `tone` prop so callers don't need to
 * carry Tailwind class strings.
 */
const TONE_CLS = {
  slate: "bg-slate-50 text-slate-900",
  rose: "bg-rose-50 text-rose-700",
  emerald: "bg-emerald-50 text-emerald-700",
};

export default function SummaryStat({ label, value, tone, testid }) {
  const toneCls = TONE_CLS[tone] || TONE_CLS.slate;
  return (
    <div className={`border border-slate-200 rounded-md p-3 ${toneCls}`} data-testid={testid}>
      <div className="text-[11px] uppercase tracking-wide opacity-80">{label}</div>
      <div className="text-2xl font-bold mt-1" style={{ fontFamily: "Outfit, sans-serif" }}>{value ?? 0}</div>
    </div>
  );
}
